import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import wrapInContainerStyles from "@insite/client-framework/Common/wrapInContainerStyles";
import siteMessage from "@insite/client-framework/SiteMessage";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getSettingsCollection } from "@insite/client-framework/Store/Context/ContextSelectors";
import getRealTimeWarehouseInventory from "@insite/client-framework/Store/Data/RealTimeInventory/Handlers/GetRealTimeWarehouseInventory";
import translate from "@insite/client-framework/Translate";
import { AvailabilityDto, AvailabilityMessageType, ProductModel, ProductSettingsModel, WarehouseDto } from "@insite/client-framework/Types/ApiModels";
import DataTable, { DataTableProps } from "@insite/mobius/DataTable";
import DataTableBody, { DataTableBodyProps } from "@insite/mobius/DataTable/DataTableBody";
import DataTableCell from "@insite/mobius/DataTable/DataTableCell";
import { DataTableCellBaseProps } from "@insite/mobius/DataTable/DataTableCellBase";
import DataTableHead, { DataTableHeadProps } from "@insite/mobius/DataTable/DataTableHead";
import DataTableHeader, { DataTableHeaderProps } from "@insite/mobius/DataTable/DataTableHeader";
import DataTableRow, { DataTableRowProps } from "@insite/mobius/DataTable/DataTableRow";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import Icon, { IconWrapper } from "@insite/mobius/Icon";
import AlertTriangle from "@insite/mobius/Icons/AlertTriangle";
import Check from "@insite/mobius/Icons/Check";
import X from "@insite/mobius/Icons/X";
import Link, { LinkPresentationProps } from "@insite/mobius/Link";
import LoadingSpinner, { LoadingSpinnerProps } from "@insite/mobius/LoadingSpinner";
import Modal, { ModalPresentationProps } from "@insite/mobius/Modal";
import Typography, { TypographyPresentationProps, TypographyProps } from "@insite/mobius/Typography";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import InfoNewIcon from "@MasterBluePrint/Icons/InfoNew";
import { FormattedCommaSeparatedValue } from "@MasterBluePrint/Services/FormattedValueService";
import { DigitalProductSetting, showForeignStockMessageSetting } from "@MasterBluePrint/Store/Context/ContextSelector";
import { showVendorStocksSetting } from "@MasterBluePrint/Store/Context/ContextSelector";
import React, { FC, useEffect, useRef, useState } from "react";
import { connect, ResolveThunks } from "react-redux";
import styled, { css } from "styled-components";

interface OwnProps {
    productId: string;
    availability?: AvailabilityDto;
    unitOfMeasure: string;
    trackInventory: boolean;
    isProductDetailsPage?: boolean;
    failedToLoadInventory?: boolean;
    extendedStyles?: ProductAvailabilityStyles;
    qtyOnHand: number;
    isDirectShip?: string;
    manufacturerItem?: string;
    isDirectShipFromManufacturer?: string;
    inventoryOutofStock?: string;
    currentWebsiteCountry?: string;
    warehousesResult?: { errorMessage: String, warehouses: WarehouseDto[] };
    softwareProduct?: string;
    calibrationService?: string;
    isCarouselProduct?:boolean;
    product?: ProductModel;
}

const mapStateToProps = (state: ApplicationState, ownProps: OwnProps) => ({
    productSettings: getSettingsCollection(state).productSettings,
    showForeignStockCountry: showForeignStockMessageSetting(state)?.showForeignStockInCountry,
    websiteState: state.context.website,
    showVendorStocksSetting: showVendorStocksSetting(state)?.showVendorStocks,
    showDigitalProduct: DigitalProductSetting(state),
});

const mapDispatchToProps = {
    getRealTimeWarehouseInventory,
};

type Props = OwnProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps>;

export interface ProductAvailabilityStyles {
    container?: GridContainerProps;
    messageGridItem?: GridItemProps;
    digitalProductHandlingLabel?: TypographyProps;
    digitalProductCarouselLabel?: TypographyProps;
    labelGridItem?: GridItemProps;
    sideWrapper?: InjectableCss;
    tooltip?: InjectableCss;
    tooltipHeading?: InjectableCss;
    tooltipContent?: InjectableCss;
    tooltipIcon?: InjectableCss;
    availabilityByWarehouseLinkGridItem?: GridItemProps;
    inventoryMessage?: InjectableCss;
    messageText?: TypographyPresentationProps;
    realTimeText?: TypographyPresentationProps;
    errorWrapper?: InjectableCss;
    errorText?: TypographyPresentationProps;
    availabilityByWarehouseLink?: LinkPresentationProps;
    availabilityByWarehouseModal?: ModalPresentationProps;
    centeringWrapper?: InjectableCss;
    spinner?: LoadingSpinnerProps;
    availabilityByWarehouseTable?: DataTableProps;
    availabilityByWarehouseTableHead?: DataTableHeadProps;
    availabilityByWarehouseTableHeader?: DataTableHeaderProps;
    availabilityByWarehouseTableBody?: DataTableBodyProps;
    availabilityByWarehouseTableRow?: DataTableRowProps;
    availabilityByWarehouseTableCell?: DataTableCellBaseProps;
    labelStyled?: InjectableCss;
    labelStyledMessage?: InjectableCss;
    IsMarginSpace?: InjectableCss;
    quantityStyled?: InjectableCss;
    quantityStyledMessage: InjectableCss;
    requestTime?: InjectableCss;
    messageTextNew?: InjectableCss;
    messageTextContainer?: InjectableCss;
    stockContainerStyle?: InjectableCss;
    outStockContainerStyle?: InjectableCss;
}

export const productAvailabilityStyles: ProductAvailabilityStyles = {
    container: {
        gap: 0,
        css: css`
            flex-grow: 0;
            // margin-bottom:.3rem;
        `,
    },
    messageGridItem: { width: 12 },
    labelGridItem: { width: 6 },
    availabilityByWarehouseLinkGridItem: { width: 12 },
    availabilityByWarehouseModal: {
        size: 400,
        cssOverrides: {
            modalContent: css`
                padding: 0;
            `,
            modalTitle: css`
                padding: .625rem .625rem .625rem 1.25rem
            `,
            headlineTypography: css`
                font-size: 1.25rem;
                margin-bottom: 0;
            `,
        },
    },
    centeringWrapper: {
        css: css`
            height: 6.25rem;
            width: 100%;
            display: flex;
            align-items: center;
        `,
    },
    spinner: {
        css: css`
            margin: 0 auto;
        `,
    },
    messageText: {
        css: css`
            width: 100%;
            ${wrapInContainerStyles}
        `,
    },
    realTimeText: {
        weight: "bold",
        css: css`
            display: inline-block;
            text-align: left;
            min-width: 1.5625rem;

            &::after {
                overflow: hidden;
                display: inline-block;
                vertical-align: bottom;
                animation: ellipsis steps(4, end) 900ms infinite 1s;
                content: "\\2026";
                width: 0;
            }

            @keyframes ellipsis {
                to {
                    width: 1.25em;
                }
            }
        `,
    },
    errorText: {
        weight: "bold",
    },
    labelStyled: {
        css: css`
        font-weight: 600 !important;
        font-size: .9rem !important;
        margin-bottom: .2em;
        font-family: 'Lato',sans-serif;
        margin-right: .5rem;
        `,
    },
    labelStyledMessage: {
        css: css`
        font-weight: 600 !important;
        font-size: .9rem !important;
        margin-bottom: .2em;
        font-family: 'Lato',sans-serif;
        margin-right: .5rem;
        display:inline !important;
        `,
    },
    quantityStyled: {
        css: css`
        font-weight: 400 !important;
        `,
    },
    quantityStyledMessage: {
        css: css`
        font-weight: 400 !important;
        color:#333f48;
        display:inline !important;
        `,
    },
    requestTime: {
        css: css`
        span {
            font-size: .9rem;
            color:#333F48 !important;
            text-decoration: underline;
            font-weight: 700 !important;
            &:hover {
                color:#2060AD !important;
            }
        }
        `,
    },
    messageTextNew: {
        css: css`
         &.availability-msg {
            display: flex;
         }
        `,
    },
    messageTextContainer: {
        css: css`
            display: flex;
            flex-direction: column;
        `,
    },
    stockContainerStyle: {
        css: css`
        display: flex;
        margin-bottom: 0.6rem;
        `,
    },
    digitalProductHandlingLabel: {
        css: css`
            position: relative;
            color: #002554;
            font-size: 0.9rem;
            font-weight: 900;
            -webkit-letter-spacing: -.019rem;
            -moz-letter-spacing: -.019rem;
            -ms-letter-spacing: -.019rem;
            letter-spacing: -.019rem;
            line-height: 1.438rem;
        `,
    },
    digitalProductCarouselLabel: {
        css: css`
            position: relative;
            color: #333F48;
            margin-top: 15px;
            font-size: 14px !important;
            font-family: 'Lato', sans-serif !important;
            font-weight: 700;
            -webkit-letter-spacing: -.019rem;
            -moz-letter-spacing: -.019rem;
            -ms-letter-spacing: -.019rem;
            letter-spacing: -.019rem;
            line-height: 1.438rem;
        `,
    },
    tooltipIcon: {
        css: css`
            display: inline-block;
            position: absolute;
            margin-left: 5px;
            z-index: 9;
            cursor:pointer;
            
            svg {
                width: 1.5rem;
                height: 1.5rem;
                scale: 0.8;
            }
        `,
    },
    tooltip: {
        css: css`
            background-color: #fff;
            box-shadow: 0 7px 17px 0 rgba(0,37,84,0.23);
            position: absolute;
            width: 250px;
            padding: 1.5625rem;
            bottom: 2.375rem;
            display: none;
            z-index: 99;

            &.active {
                display: block;
                max-width:15rem;
            }

            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        null,
                        null,
                        css`
                            max-width: 11rem !important;
                            max-height: 18rem !important;
                            margin-right: 2rem !important;
                            padding-right: 1.9rem !important;
                        `,
                        null,
                        null,
                    ],
                    "max",
                )}
        `,
    },
    tooltipHeading: {
        css: css`
            position: relative;
            color: #002554;
            font-family: Roboto;
            font-size: 1.125rem;
            font-weight: 500;
            letter-spacing: 0;
            line-height: 31px;
            margin-bottom: 20px;
            text-align: left;
            &:after {
                height: 3px;
                width: 0.665rem;;
                background-color: #C63527;
                content: '';
                display: inline-block;
                position: absolute;
                bottom: -2px;
                left: 1px;
            }
        `,
    },
    tooltipContent: {
        css: css`
            color: #424B5A;
            font-family: Lato;
            font-size: .9rem;
            letter-spacing: 0.17px;
            line-height: 1.5rem;
            text-align: left !important;
            font-weight: 500 !important;

            &:after {
                content: '';
                display: block;
                height: 0;
                position: absolute;
                width: 0;
                border: 12px solid;
                border-color: #fff transparent transparent transparent;
                z-index: 99;
                bottom: -1.4375rem;
                right: 120px;
            }

            @media screen and (min-width: 1023px) and (max-width: 1100px) {
                &:after {
                    right: 80px !important;
                }
            }

            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        null,
                        null,
                        css`
                            &:after {
                                right: 80px !important;
                            }
                        `,
                        css`
                            &:after {
                                right: 100px;
                            }
                        `,
                        null,
                    ],
                    "max",
                )}
        `,
    },
    outStockContainerStyle: {
        css: css`
            display: flex;
            margin-bottom: 0.4rem;
        `,
    }

};

const InventoryMessage = styled.div`
    display: flex;
    font-weight: 700;
    font-size: 1rem !important;
    margin-top: 0.75rem;
    font-family: 'Lato',sans-serif;
    > span:first-child {
        font-weight: 700 !important;
    }
    > span:last-child  {
        color: #333F48;
        font-family: 'Lato',sans-serif;
        font-weight: 400;
        font-size: .9rem !important;
        word-break: normal;
    }

    .mb-10 {
        margin-bottom: .6rem;
    }

    @media screen and (max-width: 1399px) {
        line-height: 1;

        .mb-10 {
            margin-bottom: .6rem;
        }
    }

    &.ship-manufacture-align {
        display: block;
    }

    .req-lead-time {
        margin-top: 10px;
    }

    .availability-msg {
        display: block;
        margin-top: 10px;
    }

    .outofStockMessage{
        margin-bottom:.6rem;
    }
    ${IconWrapper} {
        margin-right: .625rem;
    }
    ${({ theme }: { theme: BaseTheme }) =>
        breakpointMediaQueries(
            theme,
            [
                null,
                css`
                    //margin-bottom: .31250625rem;
                `,
                null,
                null,
            ],
            "max",
        )};
       
`;

const getAvailabilityColor = (productSettings: ProductSettingsModel, availabilityMessageType?: AvailabilityMessageType) => {
    if (!productSettings.showInventoryAvailability) {
        return "common";
    }

    const availabilityType = availabilityMessageType;
    if (availabilityType === AvailabilityMessageType.OutOfStock) {
        return "danger";
    }

    if (availabilityType === AvailabilityMessageType.LowStock) {
        return "warning";
    }
    if (availabilityType === AvailabilityMessageType.ShipDirecrFromManufacturer) {
        return "danger";
    }

    return "success";
};

const getAvailabilityIcon = (productSettings: ProductSettingsModel, availability?: AvailabilityDto) => {
    if (!productSettings.showInventoryAvailability) {
        return undefined;
    }

    const availabilityType = availability?.messageType;
    if (availabilityType === AvailabilityMessageType.OutOfStock) {
        return X;
    }

    if (availabilityType === AvailabilityMessageType.LowStock) {
        return AlertTriangle;
    }

    return Check;
};

const showLink = (
    availability: AvailabilityDto | undefined,
    trackInventory: boolean,
    productSettings: ProductSettingsModel,
    isProductDetailsPage?: boolean,
): boolean => {
    if (
        !availability ||
        availability.messageType === AvailabilityMessageType.NoMessage ||
        !trackInventory ||
        !productSettings.showInventoryAvailability ||
        !productSettings.displayInventoryPerWarehouse
    ) {
        return false;
    }

    if (!productSettings.displayInventoryPerWarehouseOnlyOnProductDetail) {
        return true;
    }

    return !!isProductDetailsPage;
};

const ProductAvailability = ({
    productId,
    availability,
    unitOfMeasure,
    trackInventory,
    productSettings,
    isProductDetailsPage,
    getRealTimeWarehouseInventory,
    failedToLoadInventory,
    extendedStyles,
    qtyOnHand,
    isDirectShip,
    manufacturerItem,
    isDirectShipFromManufacturer,
    inventoryOutofStock,
    websiteState,
    showForeignStockCountry,
    showVendorStocksSetting,
    currentWebsiteCountry,
    warehousesResult,
    softwareProduct,
    showDigitalProduct,
    calibrationService,
    isCarouselProduct,
    product,
}: Props) => {
    const manufacturerItemData = manufacturerItem || "";
    const isDirectShipFromManufacturerFlag = isDirectShipFromManufacturer ? isDirectShipFromManufacturer.toLowerCase() : "false";
    const [modalIsOpen, setModalIsOpen] = useState(false);
    const [warehouses, setWarehouses] = useState<WarehouseDto[] | undefined>(undefined);
    const [errorMessage, setErrorMessage] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    const [showText, setShowText] = React.useState(false);
    const digitalProductText = siteMessage("Digital_Product_Message").toString();
    const digitalProductTitle = siteMessage("Digital_Product_Title").toString();
    const calibrationServiceTitle = siteMessage("Calibration_Service_Title").toString();
    const calibrationServiceText = siteMessage("Calibration_Service_Message").toString();

    const modalCloseHandler = () => {
        setModalIsOpen(false);
    };
    const viewAvailabilityByWarehouseClickHandler = () => {
        setIsLoading(true);
        setModalIsOpen(true);
        getRealTimeWarehouseInventory({
            productId,
            unitOfMeasure,
            expand: ["warehouses"],
            onComplete: result => {
                setWarehouses(result.warehouses);
                setErrorMessage(result.errorMessage);
                setIsLoading(false);
            },
        });
    };


    const [isForeighStock, setIsForeighStock] = useState(true);

    const [foreignStockQty, setForeignStockQty] = useState(0);
    const [domesticStockQty, setDomesticStockQty] = useState(0);
    const [vendorStockQty, setVendorStockQty] = useState(0);

    const [showForeignStock, setShowForeignStock] = useState("");
    const [showVendorStock, setVendorStock] = useState(false);
    const [isEffectLoaded, setIsEffectLoaded] = useState(false);

    const loadStockQty = (warehouses: WarehouseDto[] | undefined) => {
        let domesticStockQty = 0;
        let foreignStockQty = 0;
        let vendorStock = 0;
        setIsEffectLoaded(true);
        warehouses?.forEach(resultData => {
            if (resultData?.description === "VirtualStock") {
                vendorStock += resultData?.qty;
                setVendorStockQty(vendorStock);
            }
            else if (resultData?.description === currentWebsiteCountry) {
                setIsForeighStock(false);
                domesticStockQty += resultData?.qty;
                setDomesticStockQty(domesticStockQty);
            }
            else {
                foreignStockQty += resultData?.qty;
                setForeignStockQty(foreignStockQty);
            }

        });
        setIsLoading(false);
        if (showForeignStockCountry) {
            setShowForeignStock("Yes");
        }
        else {
            setShowForeignStock("No");
        }

        if (showVendorStocksSetting) {
            setVendorStock(true);
        }
    }

    useEffect(() => {
        setIsLoading(true);
        if (currentWebsiteCountry !== "" && !isEffectLoaded) {
            if (!warehousesResult || (warehousesResult && warehousesResult.warehouses.length === 0)) {
                getRealTimeWarehouseInventory({
                    productId,
                    unitOfMeasure,
                    expand: ["warehouses"],
                    onComplete: result => {
                        loadStockQty(result?.warehouses);
                    },
                });
            }
            else {
                loadStockQty(warehousesResult?.warehouses);
            }
        }

    }, []);

    useEffect(() => {
        if (currentWebsiteCountry !== "" && !isEffectLoaded && warehousesResult) {
            loadStockQty(warehousesResult?.warehouses);
        }
    }, [warehousesResult]);

    const modalRef = useRef<HTMLDivElement>(null);
    const [isModalOpen, setModalOpen] = useState(false);
    const openModal = () => setModalOpen(true);
    const closeModal = () => setModalOpen(false);

    const calibrationServiceToolTipRef = useRef<HTMLDivElement>(null);
    const [isCalibrationServiceToolTipOpen, setIsCalibrationServiceToolTipOpen] = useState(false);
    const openCalibrationServiceToolTip = () => setIsCalibrationServiceToolTipOpen(true);
    const closeCalibrationServiceToolTip = () => setIsCalibrationServiceToolTipOpen(false);

    const handleClickOutside = (event: MouseEvent) => {
        if (modalRef.current && !modalRef.current.contains(event.target as Node)) {
            closeModal();
        }
        if (calibrationServiceToolTipRef.current && !calibrationServiceToolTipRef.current.contains(event.target as Node)) {
            closeCalibrationServiceToolTip();
        }
    };

    useEffect(() => {
        if (isModalOpen || isCalibrationServiceToolTipOpen) {
            document.addEventListener('mousedown', handleClickOutside);
        } else {
            document.removeEventListener('mousedown', handleClickOutside);
        }

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [isModalOpen, isCalibrationServiceToolTipOpen]);

    const color = getAvailabilityColor(productSettings, availability?.messageType || undefined);

    const [styles] = useState(() => mergeToNew(productAvailabilityStyles, extendedStyles));

    if (failedToLoadInventory) {
        return (
            <StyledWrapper {...styles.errorWrapper}>
                <Typography {...styles.errorText}>{siteMessage("RealTimeInventory_InventoryLoadFailed")}</Typography>
            </StyledWrapper>
        );
    }

    let inventoryTextComponent = <Typography {...styles.realTimeText} />;

    function countDigits(value: number) {
        return Math.abs(value).toString().length;
    }

    const warehousesData = warehousesResult?.warehouses ?? [];

    const isVendorStockAvailableOnly = warehousesData.length > 0 &&
        warehousesData.some(
            (w) =>
                w.name.trim().toLowerCase() === "vendor stock" &&
                w.description.trim().toLowerCase() === "virtualstock" &&
                w.qty > 0
        ) &&
        warehousesData.every(
            (w) =>
                (w.name.trim().toLowerCase() === "vendor stock" &&
                    w.description.trim().toLowerCase() === "virtualstock") ||
                w.qty === 0
        );

    const isOpenBoxOrUsed = product != null && "properties" in product
        ? "condition" in product.properties
            ? ["open box", "used"].includes(product.properties.condition.toLowerCase())
            : false
        : false;

    if (
        availability?.messageType !== AvailabilityMessageType.NoMessage &&
        availability?.message?.length &&
        isDirectShipFromManufacturerFlag !== "true" && isEffectLoaded
    ) {
        inventoryTextComponent = (
            <InventoryMessage color={color} {...styles.inventoryMessage}>
                {/* <Icon color={color} src={iconSrc} /> */}
                <Typography {...styles.messageText} data-test-selector="availabilityMessage" className={`${availability.message === "Request Lead Time" ? "req-lead-time" : "stock-container"}`} >

                    {availability.message.match(/In Stock/gi) && domesticStockQty > 0 && softwareProduct?.toString().toLowerCase() !== "true" && calibrationService?.toString().toLowerCase() !== "true" && (
                        <StyledWrapper {...styles.stockContainerStyle}>
                            <Typography>
                                <Typography {...styles.labelStyledMessage}>
                                    {siteMessage("Inventory_DomesticStockMessage")}{`: `}
                                </Typography>
                                <Typography {...styles.quantityStyledMessage} data-test-selector="dStock">{FormattedCommaSeparatedValue(domesticStockQty)}</Typography>
                            </Typography>
                        </StyledWrapper>
                    )}
                    {availability.message.match(/In Stock/gi) && showForeignStock === "Yes" && foreignStockQty > 0 && softwareProduct?.toString().toLowerCase() !== "true" && calibrationService?.toString().toLowerCase() !== "true" && (
                        <StyledWrapper {...styles.stockContainerStyle}>
                            <Typography>
                                <Typography {...styles.labelStyled}>{siteMessage("Inventory_ForeignStockMessage")}:</Typography>
                                <Typography {...styles.quantityStyled}>{FormattedCommaSeparatedValue(foreignStockQty)}</Typography>
                            </Typography>
                        </StyledWrapper>
                    )}
                    {availability.message.match(/In Stock/gi) && showVendorStock && vendorStockQty > 0 && softwareProduct?.toString().toLowerCase() !== "true" && calibrationService?.toString().toLowerCase() !== "true" && (
                        <StyledWrapper {...styles.stockContainerStyle}>
                            <Typography>
                                <Typography {...styles.labelStyled}>{siteMessage("Inventory_VendorStockMessage")}:</Typography>
                                <Typography {...styles.quantityStyled}>{FormattedCommaSeparatedValue(vendorStockQty)}</Typography>
                            </Typography>
                        </StyledWrapper>
                    )}
                    {availability.message.match(/In Stock/gi) && domesticStockQty <= 0 && foreignStockQty <= 0 && vendorStockQty <= 0 &&
                        ((showForeignStock === "No" && vendorStockQty <= 0) ||
                            (showForeignStock === "Yes" && vendorStockQty <= 0) ||
                            (showForeignStock === "No" && showVendorStock === false && vendorStockQty >= 0) ||
                            (showForeignStock === "Yes" && showVendorStock === false && vendorStockQty >= 0)
                        ) && softwareProduct?.toString().toLowerCase() !== "true"  && calibrationService?.toString().toLowerCase() !== "true" && (

                            <StyledWrapper {...styles.outStockContainerStyle}>
                                <Typography {...styles.labelStyled}>{siteMessage("Inventory_OutofStock")}</Typography>
                            </StyledWrapper>
                        )}
                    {!isVendorStockAvailableOnly && isCarouselProduct!==true && availability.message === "Request Lead Time" && softwareProduct?.toString().toLowerCase() !== "true"  && calibrationService?.toString().toLowerCase() !== "true" && (
                        <Typography>
                            <Link href={`/Request-Lead-Time?mfpn=${manufacturerItemData}`} {...styles.requestTime}>
                                <Typography>{availability.message}</Typography>
                            </Link>
                        </Typography>
                    )}
                    {availability.message !== "In Stock" && availability.message !== "Request Lead Time" && !availability.message.match(/In Stock/gi) && softwareProduct?.toString().toLowerCase() !== "true"  && calibrationService?.toString().toLowerCase() !== "true" && (
                        <Typography as="div" className="outofStockMessage">
                            <Typography>{availability.message}</Typography>
                        </Typography>
                    )}
                    {!isVendorStockAvailableOnly && isCarouselProduct!==true && availability.message !== "Request Lead Time" && inventoryOutofStock === "Request Lead Time" && softwareProduct?.toString().toLowerCase() !== "true"  && calibrationService?.toString().toLowerCase() !== "true" && (
                        <Typography as="div" className="request-link mb-10">
                            <Link href={`/Request-Lead-Time?mfpn=${manufacturerItemData}`} {...styles.requestTime}>
                                <Typography>{inventoryOutofStock}</Typography>
                            </Link>
                        </Typography>
                    )}
                    {availability.message === "Out of Stock" && isOpenBoxOrUsed && (
                        <Typography as="div" className="outofStockMessage">
                            <Typography> {siteMessage("OpenBoxOrUsedOutOfStockProductMessage")} </Typography>
                        </Typography>
                    )}
                    
                </Typography>
            </InventoryMessage>
        );
    } else if (isDirectShipFromManufacturerFlag === "true" && isEffectLoaded) {
        inventoryTextComponent = (
            <InventoryMessage
                color={getAvailabilityColor(productSettings, AvailabilityMessageType.ShipDirecrFromManufacturer)}
                {...styles.messageTextContainer}
                className="ship-manufacture-align"
            >

                {vendorStockQty > 0 && softwareProduct?.toString().toLowerCase() !== "true"  && calibrationService?.toString().toLowerCase() !== "true" && (
                    <StyledWrapper {...styles.stockContainerStyle}>
                        <Typography>
                            <Typography {...styles.labelStyled}>{siteMessage("Inventory_VendorStockMessage")}:</Typography>
                            <Typography {...styles.quantityStyled}>{FormattedCommaSeparatedValue(vendorStockQty)}</Typography>
                        </Typography>
                    </StyledWrapper>
                )}
                {!isVendorStockAvailableOnly && isCarouselProduct!==true && availability?.message === "Request Lead Time" && softwareProduct?.toString().toLowerCase() !== "true"  && calibrationService?.toString().toLowerCase() !== "true" && (
                    <Typography>
                        <Link href={`/Request-Lead-Time?mfpn=${manufacturerItemData}`} {...styles.requestTime}>
                            <Typography>{availability?.message}</Typography>
                        </Link>
                    </Typography>
                )}
                {!isVendorStockAvailableOnly && isCarouselProduct!==true && availability?.message !== "Request Lead Time" && inventoryOutofStock === "Request Lead Time" && softwareProduct?.toString().toLowerCase() === "true"  && calibrationService?.toString().toLowerCase() === "true" && (
                    <Typography as="div" className="request-link mb-10">
                        <Link href={`/Request-Lead-Time?mfpn=${manufacturerItemData}`} {...styles.requestTime}>
                            <Typography>{inventoryOutofStock}</Typography>
                        </Link>
                    </Typography>
                )}
                {/* <Icon color={color} src={iconSrc} /> */}
                <Typography {...styles.messageTextNew} data-test-selector="availabilityMessage" className="availability-msg">
                    {siteMessage("Inventory_ShipDirectFromManufacturer")}
                </Typography>

            </InventoryMessage>
        );

    } else if (availability && isEffectLoaded) {
        inventoryTextComponent = (
            <InventoryMessage
                color={getAvailabilityColor(productSettings, AvailabilityMessageType.ShipDirecrFromManufacturer)}
                {...styles.inventoryMessage}
                className="ship-manufacture-align"
            >
                {!isVendorStockAvailableOnly && isCarouselProduct!==true && inventoryOutofStock === "Request Lead Time" && softwareProduct?.toString().toLowerCase() !== "true" && (
                    <Typography as="div" className="request-link mb-10">
                        <Link href={`/Request-Lead-Time?mfpn=${manufacturerItemData}`} {...styles.requestTime}>
                            <Typography>{inventoryOutofStock}</Typography>
                        </Link>
                    </Typography>
                )}
                <Typography {...styles.messageTextNew} data-test-selector="availabilityMessage">
                    {siteMessage("Inventory_ShipDirectFromManufacturer")}
                </Typography>

            </InventoryMessage>
        );
    }


    return (
        <GridContainer {...styles.container} className="adjust-spacing">
            {showDigitalProduct?.digitalProduct && softwareProduct?.toString().toLowerCase() === "true" && (
                <GridItem {...styles.messageGridItem}>
                    <Typography className="digitalProductStyle" {...(!isProductDetailsPage ? styles.digitalProductCarouselLabel : styles.digitalProductHandlingLabel)}>
                        {digitalProductTitle}
                        <Typography as="span" {...styles.tooltipIcon}
                            onClick={() => { setShowText(true); openModal() }}
                            onKeyDown={(e: any) => e.keyCode === 27 ? setShowText(false) : ''}
                            onBlur={() => setShowText(false)}
                        >
                            <Icon src={InfoNewIcon} />
                        </Typography>
                        {isModalOpen && (
                            <div ref={modalRef}>
                                <Typography as='div' {...styles.tooltip} className={`${showText ? 'active' : ''}`} >
                                    <Typography as='h5' {...styles.tooltipHeading}>{digitalProductTitle} </Typography>
                                    <Typography as='span' {...styles.tooltipContent}>{digitalProductText} </Typography>
                                </Typography>
                            </div>
                        )}
                    </Typography>
                </GridItem>
            )}

            {calibrationService?.toString().toLowerCase() === "true" && (
                <GridItem {...styles.messageGridItem}>
                    <Typography className="digitalProductStyle" {...(!isProductDetailsPage ? styles.digitalProductCarouselLabel : styles.digitalProductHandlingLabel)}>
                        {calibrationServiceTitle}
                        <Typography as="span" {...styles.tooltipIcon}
                            onClick={() => { setShowText(true); openCalibrationServiceToolTip() }}
                            onKeyDown={(e: any) => e.keyCode === 27 ? setShowText(false) : ''}
                            onBlur={() => setShowText(false)}
                        >
                            <Icon src={InfoNewIcon} />
                        </Typography>
                        {isCalibrationServiceToolTipOpen && (
                            <div ref={calibrationServiceToolTipRef}>
                                <Typography as='div' {...styles.tooltip} className={`${showText ? 'active' : ''}`} >
                                    <Typography as='h5' {...styles.tooltipHeading}>{calibrationServiceTitle} </Typography>
                                    <Typography as='span' {...styles.tooltipContent}>{calibrationServiceText} </Typography>
                                </Typography>
                            </div>
                        )}
                    </Typography>
                </GridItem>
            )}
            <GridItem {...styles.messageGridItem}>{inventoryTextComponent}</GridItem>


            {showLink(availability, trackInventory, productSettings, isProductDetailsPage) && (

                <GridItem {...styles.availabilityByWarehouseLinkGridItem}>
                    <Link
                        {...styles.availabilityByWarehouseLink}
                        onClick={viewAvailabilityByWarehouseClickHandler}
                        data-test-selector="availabilityByWarehouseLink"
                    >
                        {translate("View Availability by Warehouse")}
                    </Link>
                    <Modal
                        {...styles.availabilityByWarehouseModal}
                        headline={translate("Warehouse Inventory")}
                        isOpen={modalIsOpen}
                        handleClose={modalCloseHandler}
                    >
                        {isLoading && (
                            <StyledWrapper {...styles.centeringWrapper}>
                                <LoadingSpinner {...styles.spinner} />
                            </StyledWrapper>
                        )}
                        {!isLoading && (
                            <>
                                {errorMessage ? (
                                    <div>{errorMessage}</div>
                                ) : (
                                    <DataTable
                                        {...styles.availabilityByWarehouseTable}
                                        data-test-selector="availabilityByWarehouseModal"
                                    >
                                        <DataTableHead {...styles.availabilityByWarehouseTableHead}>
                                            <DataTableHeader {...styles.availabilityByWarehouseTableHeader}>
                                                {translate("Warehouse")}
                                            </DataTableHeader>
                                            <DataTableHeader {...styles.availabilityByWarehouseTableHeader}>
                                                {translate("QTY")}
                                            </DataTableHeader>
                                        </DataTableHead>
                                        <DataTableBody {...styles.availabilityByWarehouseTableBody}>
                                            {warehouses?.map(warehouse => (
                                                <DataTableRow
                                                    {...styles.availabilityByWarehouseTableRow}
                                                    key={warehouse.name}
                                                >
                                                    <DataTableCell {...styles.availabilityByWarehouseTableCell}>
                                                        {warehouse.description || warehouse.name}
                                                    </DataTableCell>
                                                    <DataTableCell {...styles.availabilityByWarehouseTableCell}>
                                                        {warehouse.qty}
                                                    </DataTableCell>
                                                </DataTableRow>
                                            ))}
                                        </DataTableBody>
                                    </DataTable>
                                )}
                            </>
                        )}
                    </Modal>
                </GridItem>
            )}
        </GridContainer>
    );
};



export default connect(mapStateToProps, mapDispatchToProps)(ProductAvailability);
